<template>
    <fieldset :class="containerClasses ? containerClasses : 'grid grid-cols-2 gap-6 pt-3'">
        <div class="relative flex items-center" v-for="(option, optionIdx) in options" :key="option.type">
            <div class="flex h-5 items-center">
                <input :id="`option-${option.type}`" :name="`option-${option.type}`" v-model="modelValue" :value="option.type" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500" />
            </div>
            <div class="ml-3 text-sm flex-1 flex">
                <label :for="`option-${option.type}`" class="font-medium text-gray-700 flex-1 cursor-pointer">{{ $t(option.name) }}</label>
            </div>
        </div>
    </fieldset>
</template>

<script setup>
import {ref, watch} from "vue";

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    'modelValue': Object,
    'options': Array,
    'idPrefix': String,
    'containerClasses': String,
})

const modelValue = ref(props.modelValue);

watch(modelValue, function(newValue){
    emit('update:modelValue',newValue);
})

</script>